export class Constants {
	// api
	//public static devServerEndpoint = 'http://localhost:6509/';

	//public static devServerEndpoint = 'https://klineprosystem-dev.azurewebsites.net/';

	// Deployment
	public static devServerEndpoint = '';

	// UAT
	//public static devServerEndpoint = 'https://klineprosystem-uat.azurewebsites.net/';

	//public static devServerEndpoint = 'https://klineprosystem.azurewebsites.net/';

	public static tokenKey = 'token';
	public static tokenApiKey = 'tokenApi';
}
